import APIClient from '@/shared/http/clients/api'

const resourceName = 'TermoPrevisao'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (limit, index, companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}?limit=${limit}&index=${index}`, data, config)
const GetAllByTermo = (limit, index, termId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByTermo/${termId}?limit=${limit}&index=${index}`, data, config)
const GetDespesaFly = (termId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetDespesaFly/${termId}`, data, config)
const GetAllByTermoTotal = (termId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByTermoTotal/${termId}`, data, config)

const ForecastTermRepository = {
  GetAll,
  GetAllByTermoTotal,
  GetAllByTermo,
  GetDespesaFly

}

export default ForecastTermRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/forecastterm.js